import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));
// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

const UpdateCreditLimitModalComponent: React.FC<TopUpDealerModalPros> = ({
  show,
  handleClose,
  activeDealer,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateDealerCreditLimitProp>(
    "dealers/updateMyDealerCreditLimit",
    true
  );
  const [checked, setChecked] = useState<boolean>(
    Boolean(activeDealer.isCreditAllowed)
  );
  const onChange = (e: any) => {
    if (e.target.checked === true) {
      form.setFieldsValue({ creditLimit: activeDealer.creditLimit });
    }
    setChecked(e.target.checked);
  };
  const onFinish = (values: any) => {
    const dataToSend: UpdateDealerCreditLimitProp = {
      intPkHeadID: activeDealer.intPkHeadID,
      isCreditAllowed: checked === true ? 1 : 0,
      creditLimit: checked === true ? values.creditLimit : 0,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <MeshBillModal
        title="Update Credit Limit"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateDealerCreditLimitForm"
              form={form}
              initialValues={{ creditLimit: activeDealer.creditLimit }}
            >
              <Form.Item name="isVariableRechargeAllowed">
                <Checkbox checked={checked} onChange={onChange}>
                  <span className="create-user-form-label">
                    Credit Allowed?
                  </span>
                </Checkbox>
              </Form.Item>
              {checked === true && (
                <Form.Item
                  label={
                    <span className="create-user-form-label">Credit Limit</span>
                  }
                  name="creditLimit"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Credit Limit",
                    },
                    {
                      validator: (_, value) =>
                        value >= 0
                          ? Promise.resolve()
                          : Promise.reject(new Error("Invalid Credit Limit")),
                    },
                  ]}
                >
                  <Input
                    type="number"
                    className="user-input-general-height"
                    placeholder="50000"
                  />
                </Form.Item>
              )}
              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default UpdateCreditLimitModalComponent;
